import { logEvent, setUserId } from "firebase/analytics";
import { ButtonClickEventType } from "./constants/events";
import { analytics } from "./firebase";

// Get current userId from Redux.
// IMPORTANT: don't import the store at module scope — that can create a circular
// dependency (store -> slices -> utils/helper -> analyticsHelper -> store) and
// cause a Temporal Dead Zone error when modules are initialising. Load the
// store lazily at runtime instead.
const getUserId = (): string | null => {
  try {
    // Use a runtime require to avoid importing the store during module init.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { store } = require('../redux/app/configureStore');
    const state = store.getState();
    const profile = state?.auth?.adminProfile;
    return profile?.getCurrentUser?.nodes?.[0]?.uId ?? null;
  } catch (err) {
    // If anything goes wrong (store not ready), return null and continue.
    return null;
  }
};

// Track button clicks with unique names
export const trackButtonClick = (eventName: ButtonClickEventType, params: object = {}) => {
  if (!analytics) {
    return; // Analytics not ready
  }
  const userId = getUserId();
  if (userId) {
    setUserId(analytics, userId);
  }

  logEvent(analytics, eventName, {
    ...params,
    userId,
    timestamp: new Date().toISOString(),
  });
};

export const trackPageView = (
  event: string,
  screenName: string,
  extraParams: Record<string, any> = {}
) => {
  if (!analytics) {
    return;
  }
  const userId = getUserId();
  if (userId) {
    setUserId(analytics, userId);
  }

  logEvent(analytics, event, {
    screen_name: screenName,
    userId,
    timestamp: new Date().toISOString(),
    ...extraParams,
  });
};

interface ChimeEventParams {
  meetingId: string;
  participantId?: string;
  participantName?: string;
  extraParams?: Record<string, any>;
}

export const trackMettingEvent = (eventType: "s" | "e" | "j" | "l", params: ChimeEventParams) => {
  if (!analytics) {
    return;
  }
  const { meetingId, participantId, participantName, extraParams } = params;
  const userId = getUserId();
  if (userId) {
    setUserId(analytics, userId);
  }

  const eventName = `m_${meetingId}_${eventType}`;
  console.log(eventName, "===>eventName")

  logEvent(analytics, eventName, {
    participantId,
    participantName,
    userId,
    timestamp: new Date().toLocaleString(),
    ...extraParams,
  });
};